import { render, staticRenderFns } from "./WhyAboutPage.vue?vue&type=template&id=24073a0a&scoped=true"
import script from "./WhyAboutPage.vue?vue&type=script&lang=js"
export * from "./WhyAboutPage.vue?vue&type=script&lang=js"
import style0 from "./WhyAboutPage.vue?vue&type=style&index=0&id=24073a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24073a0a",
  null
  
)

export default component.exports